import flatpickr from "flatpickr";

document.addEventListener("DOMContentLoaded", function(event) {
	document.querySelectorAll('.datepicker').flatpickr({
		dateFormat: "Y-m-d"
	});
});
